import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ADD_CHAMP, API_ADD_TEAM_MEMBER, API_APPROVE_TEAM_MEMBER, API_EMPLOYMENT_HISTORY, API_FETCH_AGENCY, API_FETCH_DASHBOARD, API_GET_ROLES_BY_ENTITY_NAME, API_MULTIPLE_PICTURE_UPLOAD, API_PROPERTY, API_PROPERTY_DOCUMENT, API_WORK_ORDER, API_WORK_ORDER_APPROVE, API_WORK_ORDER_REJECT, DeleteAttendanceImgProof, SaveAttendanceImgProof, SaveAttendanceImgProofs, UpdateAttendanceImgProof, UpdateAttendanceImgProofStatus, UploadAttendancePicture, API_ADD_VENDOR, API_WORK_ORDER_AGENCY_APPROVE, API_BULK_WORK_ORDER, API_ADD_WO_FULFILMENT, API_SEND_CALLING_TEMPLATE, API_GET_CALLING_TEMPLATE, API_CALL_MAKE, API_GET_CALL_MADE, GET_ALL_AGENTS, GET_AGENT, FETCH_RECRUITMENT_CANDIDATES, FETCH_CANDIDATE_PERSONAL_DETAILS, FETCH_PERSONAL_DETAILS_HOA_URL, FETCH_MORE_LEADS_HOA_URL, FETCH_CANDIDATE_DETAILS, RUN_OUTREACH, CREDIT_USAGES_SUMMARY, API_UPDATE_JOB_STATUS, API_WHATSAPP_OUTREACH, PROJECT_API_KEY, CREATE_LIBRARY_AGENT, UPDATE_LIBRARY_AGENT, GENERATE_AGENT_PROMPT, BIND_PROJECT_AGENTS, GET_MODELS, GET_VOICES, GET_LANGUAGES, GET_AMBIENT_AUDIOS, GET_EMOTIONS, GET_NUMBERS, ASSIGN_INBOUND, REMOVE_INBOUND, DELETE_AGENT } from '../../../@core/services/util/api.endpoints';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import * as _ from 'lodash';
import { AuthService } from 'src/@core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseAdminService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  // get work order api
  searchAndSortWorkOrder(page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = API_FETCH_DASHBOARD + '?page=' + page;

    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  // get Call api
  searchAndSortCalls(entityId: any, entityType: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    url = API_GET_CALLING_TEMPLATE
    // if (entityId) {
    //   url = API_GET_CALLING_TEMPLATE + '/' + entityId + '?entityType=' + entityType;
    // } else {
    //   url = API_GET_CALLING_TEMPLATE + '?entityType=' + entityType;
    // }

    url += '?page=' + page;
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  // create work order api
  createWorkOrder(payload: any): Observable<any> {
    console.log(payload)
    return this.http.post<any>(API_WORK_ORDER, payload);
  }

  createBulkWorkOrder(file: File, requestPayload: any): Observable<any> {
    // Create a new FormData instance
    const formData = new FormData();

    // Append the file with the correct key and filename
    formData.append('workOrderFile', file, file.name);

    // Append the JSON payload as a string
    formData.append('workOrderRequest', JSON.stringify(requestPayload));

    // Send the formData using HTTP POST
    return this.http.post(API_BULK_WORK_ORDER, formData, {
      reportProgress: true,
      observe: 'events' // Optional: To observe progress events
    });
  }

  uploadMultipleChampsInBulkWorkOrder(file: File, requestPayload: any): Observable<any> {
    // Create a new FormData instance
    const formData = new FormData();

    // Append the file with the correct key and filename
    formData.append('fulfilmentFile', file, file.name);

    // Append the JSON payload as a string
    formData.append('workOrderRequest', JSON.stringify(requestPayload));

    // Send the formData using HTTP POST
    return this.http.post(API_ADD_WO_FULFILMENT, formData, {
      reportProgress: true,
      observe: 'events' // Optional: To observe progress events
    });
  }

  uploadCallingTemplate(file: File, requestPayload?: any): Observable<any> {
    // Create a new FormData instance
    const formData = new FormData();

    // Append the file with the correct key and filename
    formData.append('leadsFile', file, file.name);

    // Append the JSON payload as a string
    // formData.append('workOrderRequest', JSON.stringify(requestPayload));

    // Send the formData using HTTP POST
    return this.http.post(API_SEND_CALLING_TEMPLATE, formData, {
      reportProgress: true,
      observe: 'events' // Optional: To observe progress events
    });
  }

  // update work order api
  updateWorkOrder(payload: any): Observable<any> {
    console.log(payload)
    return this.http.put<any>(API_WORK_ORDER + '/' + payload.id, payload);
  }

  updateWorkOrderVenue(payload: any): Observable<any> {
    console.log("payload", payload)
    return this.http.put<any>(API_WORK_ORDER + '/' + payload.id + '/venue', payload);
  }

  // create venue order api
  createVenue(formData: any): Observable<any> {
    console.log(formData)
    return this.http.post<any>(API_PROPERTY, formData);
  }

  // fetch Venue
  fetchVenue(page: number, size: number, sort: string, order: string): Observable<any[]> {
    let url = API_PROPERTY + '?page=' + page;

    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    return this.http.get<any[]>(url);
  }

  // upload venue picture
  uploadPicture(file: File, index): Observable<any[]> {
    const formData: FormData = new FormData();
    formData.append('profile', file, file.name);
    return this.http.post<any>(API_PROPERTY_DOCUMENT, formData, {
      reportProgress: true
    });
  }

  // upload task picture
  UploadAttendancePicture(id, file: File, index): Observable<any[]> {
    const formData: FormData = new FormData();
    formData.append('image', file, file.name);
    return this.http.post<any>(UploadAttendancePicture + '/' + id, formData, {
      reportProgress: true
    });
  }

  // upload task pictures 
  UploadAttendancePictures(id, file: File[], index): Observable<any[]> {
    const formData: FormData = new FormData();
    file.forEach(ele => {
      formData.append('images', ele, ele.name);
    })
    let paramType = "orderId";
    return this.http.post<any>(API_MULTIPLE_PICTURE_UPLOAD + '/' + id + '?paramType=' + paramType, formData, {
      reportProgress: true
    });
  }

  // get work order by id
  getWorkOrderById(id: any): Observable<any> {
    const url = API_WORK_ORDER + '/' + id;
    return this.http.get<PageableResponse<any>>(url);
  }

  // get work order by id
  getVenueById(id: any): Observable<any> {
    const url = API_PROPERTY + '/' + id;
    return this.http.get<PageableResponse<any>>(url);
  }

  // approve work order
  approveWorkOrder(id: any, obj): Observable<any> {
    const url = API_WORK_ORDER_APPROVE + '/' + id;
    return this.http.put<any>(url, obj);
  }

  approveWorkOrderByAgency(id: any, obj): Observable<any> {
    const url = API_WORK_ORDER_AGENCY_APPROVE + '/' + id + '/AGENCY_APPROVED';
    return this.http.put<any>(url, obj)
  }

  // reject work order
  rejectWorkOrder(id: any, obj): Observable<any> {
    const url = API_WORK_ORDER_REJECT + '/' + id;
    return this.http.put<any>(url, obj);
  }

  // reject work order by agency
  rejectWorkOrderByAgency(id: any, obj): Observable<any> {
    const url = API_WORK_ORDER_AGENCY_APPROVE + '/' + id + '/AGENCY_REJECTED';
    return this.http.put<any>(url, obj)
  }

  // get roles by  entity name
  getRolesByEntityName(entity_name: any): Observable<any> {
    const url = API_GET_ROLES_BY_ENTITY_NAME + '/' + entity_name;
    return this.http.get<PageableResponse<any>>(url);
  }

  // create team member api
  createTeamMember(id: any, payload: any): Observable<any> {
    const url = API_ADD_TEAM_MEMBER + '/' + id;
    return this.http.post<any>(url, payload);
  }

  // Update status of team member
  updateTeamMemberStatus(id: any, status: any): Observable<any> {
    const url = API_APPROVE_TEAM_MEMBER + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }

  // create team member api
  createChamp(id: any, payload: any): Observable<any> {
    const url = API_ADD_CHAMP + '/' + id;
    return this.http.post<any>(url, payload);
  }

  // Update status of champ
  updateChampStatus(id: any, status: any): Observable<any> {
    const url = API_FETCH_AGENCY + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }

  // Save Attendance Img Proof
  SaveAttendanceImgProof(payload) {
    const url = SaveAttendanceImgProof;
    return this.http.put<any>(url, payload);
  }

  // Save Attendance Imgs Proofs
  SaveAttendanceImgProofs(payload) {
    const url = SaveAttendanceImgProofs;
    return this.http.put<any>(url, payload);
  }

  // Update Attendance Img Proof
  UpdateAttendanceImgProof(payload) {
    const url = UpdateAttendanceImgProof;
    return this.http.post<any>(url, payload);
  }

  // Update Attendance Img Proof
  DeleteAttendanceImgProof(payload) {
    const url = DeleteAttendanceImgProof;
    return this.http.post<any>(url, payload);
  }

  updateTaskStatus(payload) {
    const url = UpdateAttendanceImgProofStatus;
    // return this.http.post<PageableResponse<any>>(url, { params: payload });
    return this.http.post<any>(url, payload);
  }

  getEmployemnetHistory(employmentId: string) {
    let url = API_EMPLOYMENT_HISTORY + `?employmentId=` + employmentId;
    return this.http.get<any>(url);
  }

  addVendor(entityId: string, vendorData: any): Observable<any> {
    const url = API_ADD_VENDOR + `${entityId}?addParent=false`;
    return this.http.post<any>(url, vendorData);
  }

  callSelectedUsers(agent_id: string, project_id: string, entity_id: string, obj): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const url = API_CALL_MAKE + `?client_call=true&entity_id=${entity_id}&agent_id=${agent_id}&project_id=${project_id}`;
    return this.http.post<any>(url, obj, { headers });
  }

  getCreditSummary(entity_id: string, page: number, size: number, filterBy?: string[]): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': PROJECT_API_KEY,
      'Content-Type': 'application/json; charset=utf-8'
    });

    // Base URL from the provided constant
    let url = `${CREDIT_USAGES_SUMMARY}?entity_id=${entity_id}&page=${page}&page_size=${size}`;

    if (filterBy) {
      filterBy.forEach(filter => {
        url += `&filter_by=${filter}`;
      });
    }

    return this.http.get<any>(url, { headers });
  }

  // getCallHistory(entity_id: string) {
  //   const headers = new HttpHeaders({
  //     Authorization: this.authService.basicAuthHeader,
  //     "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //   });
  //   let url = API_GET_CALL_MADE + `?entity_id=` + entity_id;
  //   return this.http.get<any>(url, { headers });
  // }
  getAllCallHistory(params: any) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const baseURL = `${API_GET_CALL_MADE}`;
    const url = baseURL + '?' + params;

    return this.http.get<any>(url, { headers });
  }

  getCallHistory(entity_id: string, agent_id: string, maxPageSize: number, pageNum: number) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const baseURL = `${API_GET_CALL_MADE}?entity_id=${entity_id}&maxPageSize=${maxPageSize}&pageNum=${pageNum}`;
    const url = agent_id ? `${baseURL}&agent_id=${agent_id}` : baseURL;

    return this.http.get<any>(url, { headers });
  }
  getCallHistoryProject(
    entity_id: string,
    project_id: string | null | undefined,
    maxPageSize: number,
    pageNum: number,
    agent_id?: any,
    filters?: {
      status?: string; name?: string; mobile?: string; duration?: string | number;
      observed_status?: string; reviewed_by_human?: boolean;
      /** IST YYYY-MM-DD. Send both or neither — the API rejects half a range. */
      start_date?: string; end_date?: string;
      /** Only leads assigned to this user through an outcome's assign_users. */
      user_id?: string;
      /** Only meaningful together with start_date/end_date. 'lead_added'
       *  re-scopes the same window to when leads were ingested rather than
       *  when they were last contacted (the API's default). */
      date_basis?: 'latest_contact' | 'lead_added';
      /** Latest job signal.strength (comma-separated: Strong, Good, Weak, No signal, Excluded). */
      signal_strength?: string;
    }
  ) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    let params = new HttpParams()
      .set('entity_id', entity_id)
      .set('pageSize', String(maxPageSize))
      .set('pageNum', String(pageNum));

    if (project_id != null && String(project_id).trim() !== '') {
      params = params.set('project_id', String(project_id));
    }

    if (agent_id) {
      params = params.set('agent_id', String(agent_id));
    }
    if (filters && filters.status) {
      params = params.set('status', filters.status);
    }
    // Leads that have ever held the status, rather than those at it now. The
    // backend serves it from the same rollup leadsStatusCount reads, so the
    // list matches the count on the card.
    if (filters && filters.observed_status) {
      params = params.set('observed_status', filters.observed_status);
    }
    if (filters && filters.reviewed_by_human === true) {
      params = params.set('reviewed_by_human', 'true');
    } else if (filters && filters.reviewed_by_human === false) {
      params = params.set('reviewed_by_human', 'false');
    }
    if (filters && filters.name) {
      params = params.set('name', filters.name);
    }
    if (filters && filters.mobile) {
      params = params.set('mobile', filters.mobile);
    }
    if (filters && filters.duration !== undefined && filters.duration !== null && String(filters.duration).trim() !== '') {
      params = params.set('duration', String(filters.duration));
    }
    // Restricts the list to leads called inside the window: a lead's row is its
    // latest call in the window, and its credits cover only that window.
    if (filters && filters.start_date && filters.end_date) {
      params = params.set('start_date', filters.start_date);
      params = params.set('end_date', filters.end_date);
    }
    if (filters && filters.user_id) {
      params = params.set('userId', filters.user_id);
    }
    if (filters && filters.date_basis) {
      params = params.set('date_basis', filters.date_basis);
    }
    if (filters && filters.signal_strength) {
      params = params.set('signal_strength', filters.signal_strength);
    }

    return this.http.get<any>(API_GET_CALL_MADE, { headers, params });
  }

  getUpdatedStatus(job_id: string, entity_id: string, agent_id?: string) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    let url = API_GET_CALL_MADE + `?job_id=` + job_id + `&entity_id=` + entity_id;

    if (agent_id) {
      url += `&agent_id=` + agent_id;
    }

    return this.http.get<any>(url, { headers });
  }

  getAllAgentsByEntityId(entity_id: string, maxPageSize: number, pageNum: number, project_id?: any) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    let url = GET_ALL_AGENTS + `?entity_id=` + entity_id + '&size=' + maxPageSize + '&page=' + pageNum;

    if (project_id) {
      url = url + '&project_id=' + project_id;
    }
    return this.http.get<any>(url, { headers });
  }

  getAgentById(entityId: string, agentId: string) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = GET_AGENT + `?entity_id=${entityId}&agent_id=${agentId}`;
    return this.http.get<any>(url, { headers });
  }

  private projectJsonHeaders() {
    return new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json; charset=utf-8',
      'x-suppress-error': 'true'
    });
  }

  createLibraryAgent(body: any) {
    return this.http.post<any>(CREATE_LIBRARY_AGENT, body, { headers: this.projectJsonHeaders() });
  }

  updateLibraryAgent(body: any) {
    return this.http.post<any>(UPDATE_LIBRARY_AGENT, body, { headers: this.projectJsonHeaders() });
  }

  generateAgentPrompt(body: any) {
    return this.http.post<any>(GENERATE_AGENT_PROMPT, body, { headers: this.projectJsonHeaders() });
  }

  bindProjectAgents(body: any) {
    return this.http.post<any>(BIND_PROJECT_AGENTS, body, { headers: this.projectJsonHeaders() });
  }

  getModels() {
    return this.http.get<any>(GET_MODELS, { headers: this.projectJsonHeaders() });
  }

  getVoices() {
    return this.http.get<any>(GET_VOICES, { headers: this.projectJsonHeaders() });
  }

  getLanguages(transcriptionProvider?: string) {
    let url = GET_LANGUAGES;
    if (transcriptionProvider) {
      url += `?transcription_provider=${encodeURIComponent(transcriptionProvider)}`;
    }
    return this.http.get<any>(url, { headers: this.projectJsonHeaders() });
  }

  getAmbientAudios() {
    return this.http.get<any>(GET_AMBIENT_AUDIOS, { headers: this.projectJsonHeaders() });
  }

  getEmotions() {
    return this.http.get<any>(GET_EMOTIONS, { headers: this.projectJsonHeaders() });
  }

  getNumbers() {
    return this.http.get<any>(GET_NUMBERS, { headers: this.projectJsonHeaders() });
  }

  assignInbound(body: any) {
    return this.http.post<any>(ASSIGN_INBOUND, body, { headers: this.projectJsonHeaders() });
  }

  removeInbound(body: any) {
    return this.http.post<any>(REMOVE_INBOUND, body, { headers: this.projectJsonHeaders() });
  }

  deleteAgent(entityId: string, agentId: string) {
    const url = `${DELETE_AGENT}?entity_id=${encodeURIComponent(entityId)}&agent_id=${encodeURIComponent(agentId)}`;
    return this.http.delete<any>(url, { headers: this.projectJsonHeaders() });
  }

  fetchRecruitmentCandidates(project_id: string, entity_id: string, user_config: string) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const body = {
      user_config: user_config,
      page: 1,
      per_page: 10,
      project_id: project_id,
      entity_id: entity_id
    };

    return this.http.post(
      FETCH_RECRUITMENT_CANDIDATES,
      body,
      { headers }
    );
  }

  fetchCandidatePersonalDetails(linkedin_url: string, reveal_param: string, people_id: string, project_id: string) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const body = {
      linkedin_url: linkedin_url,
      reveal_param: reveal_param,
      people_id: people_id,
      project_id: project_id
    }

    return this.http.post(
      FETCH_CANDIDATE_PERSONAL_DETAILS, body, { headers });
  }

  fetchCandidatePersonalDetailsHOA(linkedin_url: string, reveal_param: string, people_id: string, project_id: string, entityId: string) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const body = {
      linkedin_url: linkedin_url,
      reveal_param: reveal_param,
      people_id: people_id,
      project_id: project_id,
      entityId: entityId
    }

    return this.http.post(
      FETCH_PERSONAL_DETAILS_HOA_URL, body, { headers });
  }

  fetchMoreCandidatesHOA(object: any) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      FETCH_MORE_LEADS_HOA_URL, object, { headers });
  }

  fetchCandidatesDeatails(people_id: string, project_id: string, client_number: string) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    let params = new HttpParams().set('project_id', String(project_id || '').trim());
    const number = String(client_number || '').trim();
    if (number) {
      params = params.set('client_number', number);
    }
    const pid = String(people_id || '').trim();
    // Omit empty/undefined people_id — BE keys history by project_id + client_number.
    if (pid && pid !== 'undefined' && pid !== 'null') {
      params = params.set('people_id', pid);
    }
    return this.http.get<any>(API_UPDATE_JOB_STATUS, { headers, params });
  }

  runOutreach(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      RUN_OUTREACH,
      payload,
      { headers }
    );
  }

  startWhatsAppOutreach(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      API_WHATSAPP_OUTREACH,
      payload,
      { headers }
    );
  }
}
